<template>
  <v-flex
    xs12
    sm8
    md6
    class="main-col"
  >
    <p
      class="gotham-m guide-title"
      transition="scale-transition"
    >AIR</p>
    <p class="gotham-m guide-desc">{{ $t('t4') }}</p>
    <v-card class="lbt-card">
      <v-card-media
        v-bind:src="require('../images/air_2020/kv_air.png')"
        height="270px"
      ></v-card-media>
      <v-card-title
        primary-title
        class="card-content"
        :style="{ marginTop: 0 }"
      >
        <ul id="menu">
          <li @click="$vuetify.goTo('#download')">
            {{ $t('t7') }}
          </li>
          <li @click="$vuetify.goTo('#interface')">
            {{ $t('t8') }}
          </li>
          <li @click="$vuetify.goTo('#poweron_off')">
            {{ $t('t9') }}
          </li>
          <li @click="$vuetify.goTo('#connect')">
            {{ $t('t10') }}
          </li>
          <li @click="$vuetify.goTo('#basic_operation')">
            {{ $t('t11') }}
          </li>
          <li @click="$vuetify.goTo('#active_voice_assistant')">
            {{ $t('t12') }}
          </li>
          <!-- 只是暂时注释了 开关透明模式和佩戴贴合度检测 两部分 所以和所语言文件对不上 之后更新多语言需要注意删掉该部分内容 2022-10-13 10:27:16 -->
          <!-- <li @click="$vuetify.goTo('#transparency_on_off')">
            {{ $t('t13') }}
          </li> -->
          <li @click="$vuetify.goTo('#multiple_connect')">
            {{ $t('t14') }}
          </li>
          <li @click="$vuetify.goTo('#hand_control')">
            {{ $t('t15') }}
          </li>
          <li @click="$vuetify.goTo('#wear_detect')">
            {{ $t('t16') }}
          </li>
          <li @click="$vuetify.goTo('#sleep')">
            {{ $t('t17') }}
          </li>
          <li @click="$vuetify.goTo('#status')">
            {{ $t('t18') }}
          </li>
          <!-- <li @click="$vuetify.goTo('#wear_fit_detect')">
            {{ $t('t19') }}
          </li> -->
          <li @click="$vuetify.goTo('#faq')">
            {{ $t('t20') }}
          </li>
          <li @click="$vuetify.goTo('#spec')">
            {{ $t('t21') }}
          </li>
        </ul>
      </v-card-title>
    </v-card>
    <!--下载-->
    <v-card
      id="download"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t22')}}</p>
        <p class="lbt-content">{{ $t('t23') }}</p>
        <v-layout
          row
          justify-center
          align-center
        >
          <v-flex xs8>
            <v-layout
              column
              align-center
            >
              <img
                src="../images/air_2020/app_logo.png"
                class="full-pic"
              >
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
    <!--按键及接口说明-->
    <v-card
      id="interface"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t24')}}</p>
        <img
          src="../images/air_2020/interface.png"
          class="full-pic"
        />
        <p class="lbt-content-light">{{ $t('t25') }}</p>
        <p class="lbt-content-light">{{ $t('t26') }}</p>
      </v-card-title>
    </v-card>
    <!--开关机-->
    <v-card
      id="poweron_off"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t27')}}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/power_on.png" />{{ $t('t28') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/power_off.png" />{{ $t('t29') }}</p>
      </v-card-title>
    </v-card>
    <!--连接-->
    <v-card
      id="connect"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t30')}}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/connect01.gif" />{{ $t('t31') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-flex"><img src="../images/air_2020/connect02.png" />{{ $t('t32') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-flex"><img src="../images/air_2020/connect03.png" />{{ $t('t33') }}</p>
      </v-card-title>
    </v-card>
    <!--基本操作-->
    <v-card
      id="basic_operation"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t34')}}</p>
        <p class="lbt-content-dark">{{ $t('t35') }}</p>
        <img
          src="../images/air_2020/gesture_control.png"
          class="full-pic"
        />
        <p class="lbt-content">{{ $t('t36') }}</p>
        <p class="lbt-content-light">{{ $t('t37') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t38') }}</p>
        <img
          src="../images/air_2020/function_button.png"
          class="full-pic"
        />
        <p class="lbt-content">{{ $t('t39') }}</p>
        <p class="lbt-content">{{ $t('t40') }}</p>
      </v-card-title>
    </v-card>
    <!--激活语音助手-->
    <v-card
      id="active_voice_assistant"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t41') }}</p>
        <img
          src="../images/air_2020/voice_assistant.png"
          class="full-pic"
        />
        <p class="lbt-content">{{ $t('t42') }}</p>
      </v-card-title>
    </v-card>
    <!--开关透明模式-->
    <!-- <v-card
      id="transparency_on_off"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t43') }}</p>
        <img
          src="../images/air_2020/anc_switch_air.png"
          class="full-pic"
        />
        <p class="lbt-content">{{ $t('t44') }}</p>
      </v-card-title>
    </v-card> -->
    <!--多设备连接切换-->
    <v-card
      id="multiple_connect"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t45') }}</p>
        <img
          src="../images/air_2020/device_switch.png"
          class="full-pic"
        />
        <p class="lbt-content">{{ $t('t46') }}</p>
      </v-card-title>
    </v-card>
    <!--手势控制功能定制-->
    <v-card
      id="hand_control"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t47') }}</p>
        <p class="lbt-content">{{ $t('t48') }}</p>
        <p class="lbt-content-light">{{ $t('t49') }}</p>
        <img
          v-if="lang === '简体中文'"
          src="../images/air_2020/tap_function_air_cn.gif"
          class="full-pic"
        />
        <img
          v-else
          src="../images/air_2020/tap_function_air_eu.gif"
          class="full-pic"
        />
      </v-card-title>
    </v-card>
    <!--佩戴检测-->
    <v-card
      id="wear_detect"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t50') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/wear_detect1.gif" />{{ $t('t51') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/wear_detect2.gif" />{{ $t('t52') }}</p>
      </v-card-title>
    </v-card>
    <!--休眠-->
    <v-card
      id="sleep"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t53') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/sleep01.png" />{{ $t('t54') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/sleep02.png" />{{ $t('t55') }}</p>
      </v-card-title>
    </v-card>
    <!--状态指示-->
    <v-card
      id="status"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t56')}}</p>
        <p class="lbt-content-dark">{{ $t('t57') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/status_indication02.gif" />{{ $t('t58') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/status_indication03.gif" />{{ $t('t59') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/status_indication04.gif" />{{ $t('t60') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/status_indication05.gif" />{{ $t('t61') }}</p>
        <p class="lbt-content-light">{{ $t('t62') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t63') }}</p>
        <p class="lbt-content">{{ $t('t64') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/battery_level_01.gif" />{{ $t('t65') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/battery_level_02.gif" />{{ $t('t66') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/battery_level_03.gif" />{{ $t('t67') }}</p>
        <p class="lbt-content-flex"><img src="../images/air_2020/battery_level_04.gif" />{{ $t('t68') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t69') }}</p>
        <img
          src="../images/air_2020/charging_indicator.png"
          class="full-pic"
        />
        <p class="lbt-content">{{ $t('t70') }}</p>
      </v-card-title>
    </v-card>
    <!--佩戴贴合度检测-->
    <!-- <v-card
      id="wear_fit_detect"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t71') }}</p>
        <p class="lbt-content">{{ $t('t72') }}</p>
        <p class="lbt-content">{{ $t('t73') }}</p>
        <img
          v-if="lang === '简体中文'"
          src="../images/air_2020/ear_tip_fit_test_cn.gif"
          class="full-pic"
        />
        <img
          v-else
          src="../images/air_2020/ear_tip_fit_test_eu.gif"
          class="full-pic"
        />
      </v-card-title>
    </v-card> -->
    <!--常见问题-->
    <v-card
      id="faq"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t74')}}</p>
        <p class="lbt-content-dark">{{ $t('t75') }}</p>
        <p class="lbt-content">{{ $t('t76') }}</p>
        <p class="lbt-content-light">{{ $t('t77') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t78') }}</p>
        <p class="lbt-content">{{ $t('t79') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t80') }}</p>
        <p class="lbt-content">{{ $t('t81') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t82') }}</p>
        <p class="lbt-content">{{ $t('t83') }}</p>
        <p class="lbt-content-light">{{ $t('t84') }}</p>
      </v-card-title>
    </v-card>
    <!--产品参数-->
    <v-card
      id="spec"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t85')}}</p>
        <p class="lbt-content-dark">{{ $t('t86') }}</p>
        <p class="lbt-content">{{ $t('t87') }}</p>
        <p class="lbt-content-dark">{{ $t('t88') }}</p>
        <p class="lbt-content">{{ $t('t89') }}</p>
        <p class="lbt-content-dark">{{ $t('t90') }}</p>
        <p class="lbt-content">{{ $t('t91') }}</p>
        <p class="lbt-content-dark">{{ $t('t92') }}</p>
        <p class="lbt-content">{{ $t('t93') }}</p>
        <p class="lbt-content-dark">{{ $t('t94') }}</p>
        <p class="lbt-content">{{ $t('t95') }}</p>
        <p class="lbt-content-dark">{{ $t('t96') }}</p>
        <p class="lbt-content">{{ $t('t97') }}</p>
        <p class="lbt-content">{{ $t('t98') }}</p>
        <p class="lbt-content-dark">{{ $t('t99') }}</p>
        <p class="lbt-content">{{ $t('t100') }}</p>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'Content',
  props: ['lang']
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/air_2020/content.vue